import server from "@/api/server";

async function getRules() {
  server.get("/agent/management/promotion/rules-tpl");
}

async function getPromos(data) {
  const res = await server.post("/agent/management/promotion/list", data);
  return res;
}

async function getAppliedPromos(profile_id) {
  const res = await server.post("/agent/management/promotion/list-for-profile", { profile_id });
  return res;
}

async function applyPromoToId(data) { // {promo_id, profile_id}
  const res = await server.post("/agent/management/promotion/apply-to-profile", data);
  return res;
}

async function deactivatePromo(id) {
  const res = await server.post("/agent/management/promotion/deactivate", { id: id });
  return res;
}

async function createPromosBase(payload) { //{ name, description, for_all }
  const id = await server.post("/agent/management/promotion/create", payload);
  return id;
}

async function addRule(id, rule) {
  await server.post("/agent/management/promotion/add-rule", {
    id,
    ...rule,
  });
}

async function createPromo(common, rules) {
  const data = await createPromosBase(common);
  const id = data.id;
  rules.forEach((rule) => addRule(id, rule));
}

export { getPromos, getRules, deactivatePromo, createPromo, applyPromoToId, getAppliedPromos };
